/* eslint-disable */
import ComponentHeader from './Header'
import ComponentMobileMenu from './MobileMenu'
import ComponentPageHeader from './PageHeader'
import ComponentAccordions from './Accordions'
import ComponentVideo from './Video'
import ComponentGalleryGrid from './GalleryGrid'
import ComponentGallerySlider from './GallerySlider'
import ComponentTeamSlider from './TeamSlider'
import CreateList from './CreateList'
import PrintList from './PrintList'
import ScrollingLinks from './ScrollingLinks'
import WhyTasmania from './WhyTasmania'
import FilterSwitch from './FilterSwitch'

const components = {
  ComponentHeader,
  ComponentMobileMenu,
  ComponentPageHeader,
  ComponentAccordions,
  ComponentVideo,
  ComponentGalleryGrid,
  ComponentGallerySlider,
  ComponentTeamSlider,
  CreateList,
  PrintList,
  ScrollingLinks,
  WhyTasmania,
  FilterSwitch,
}

export default components



// WEBPACK FOOTER //
// ./scripts/components/index.js